import React from "react";
import { TextField as MuiTextField, TextFieldProps } from "@mui/material";
import { RootState } from "../../store/Index";
import { useSelector } from "react-redux";

type CustomTextFieldProps = TextFieldProps & {};

const CustomTextField: React.FC<CustomTextFieldProps> = ({ sx, ...props }) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);

  return (
    <MuiTextField
      fullWidth
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "10px",
          "& fieldset": {
            border: `1px solid ${reduxTheme.primary_colors[400]}`,
          },
          "&.Mui-focused fieldset": { borderColor: "#614438" },
        },
        "& .MuiInputLabel-root": {
          color: reduxTheme.primary_colors[400],
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "#614438",
        },
        ...sx,
      }}
      {...props}
    />
  );
};

export default CustomTextField;
